<div
  class="hero_in detail_page background-image"
  appBackgroundImage
  [attr.data-image]="establishment?.image"
>
  <div class="wrapper opacity-mask" data-opacity-mask="rgba(0, 0, 0, 0.5)">
    <div class="container">
      <div class="main_info">
        <div class="row">
          <div class="col-xl-4 col-lg-5 col-md-6">
            <h1>{{ establishment?.name }}</h1>
            <p [innerHTML]="establishment | translation | linebreaks"></p>
            <a
              [href]="
                'https://www.google.com/maps?saddr&daddr=' +
                establishment?.formattedAddress
              "
              target="_blank"
            >
              {{ establishment?.formattedAddress }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="wave gray hero"></div>
</div>
